function stateWebsitesNav(width) {

    let link        = $('._js-state-website-link');
    let linkBack    = $('._js-state-website-link-back');
    let content     = $('._js-state-website-content');

    link.on('click', function(e){
        e.preventDefault();

        let id = $(this).attr('data-link');

        link.removeClass('_active');
        content.removeClass('_visible');
        if ( !$(this).hasClass('_active') ) {
            $(this).addClass('_active');
            $("[data-content='" + id + "']").addClass('_visible');
        }

    });

    linkBack.on('click', function(){
        $(this).parents('._js-state-website-content').removeClass('_visible');
    });

    $(window).on('load resize', function(){
        let screen = $(window).width();

        if ( screen <= width ) {
            link.removeClass('_active');
            content.removeClass('_visible');
        }
        else {
            $('._js-state-website-link:first-child').addClass('_active');
            $('._js-state-website-content:first-child').addClass('_visible');
        }
    });
}